import { create as n } from "./util/create.js";
const r = n({
  space: "xlink",
  transform(e, l) {
    return "xlink:" + l.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});
export {
  r as xlink
};
//# sourceMappingURL=xlink.js.map
